import React from "react";
import { Flame } from "lucide-react";
import FireParticles from "./FireParticles";
import { TID } from "@/lib/testIds";

export default function FinalCTA({ onBuy }) {
  return (
    <section className="relative overflow-hidden bg-black px-5 py-20">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[600px] w-[600px] -translate-x-1/2 rounded-full bg-fire-radial blur-2xl" />
      <FireParticles count={18} />
      <div className="relative mx-auto max-w-3xl text-center">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#FF7A00]/40 bg-black/40 px-3 py-1 text-[11px] uppercase tracking-[0.22em] text-[#FFC107] backdrop-blur">
          <Flame size={14} className="text-[#FF7A00]" /> Ready to begin
        </div>
        <h2 className="font-display text-5xl leading-[0.95] text-white sm:text-6xl">
          Ready To Build Your <br />
          <span className="text-fire">Strength Naturally?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-sm text-neutral-400">
          Launch price ends soon. Get Bajrang Veda + ₹3000 free bonuses today.
        </p>
        <button
          data-testid={TID.finalBuyBtn}
          onClick={onBuy}
          className="mt-8 inline-flex items-center gap-3 rounded-full bg-fire px-10 py-5 font-bold uppercase tracking-widest text-black animate-pulse-orange transition-transform hover:scale-[1.03] active:scale-[0.98]"
        >
          Buy Now — ₹749
        </button>
        <div className="mt-4 text-xs text-neutral-500">
          UPI · Visa · Mastercard · RuPay · COD · SSL Secure
        </div>
      </div>
    </section>
  );
}
